function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9998 34.8334C27.7443 34.8334 34.8332 27.7446 34.8332 19.0001C34.8332 10.2556 27.7443 3.16675 18.9998 3.16675C10.2553 3.16675 3.1665 10.2556 3.1665 19.0001C3.1665 27.7446 10.2553 34.8334 18.9998 34.8334ZM14.2131 21.8501H18.4999C18.7356 21.8501 18.8535 21.8501 18.9267 21.9233C18.9999 21.9965 18.9999 22.1144 18.9999 22.3501V30.9799C18.9999 31.8706 18.9999 32.3159 19.1961 32.3592C19.3923 32.4024 19.5794 31.9982 19.9536 31.19L25.6016 18.9903L25.6016 18.9903C26.1934 17.7122 26.4892 17.0731 26.1943 16.6116C25.8994 16.1501 25.1951 16.1501 23.7867 16.1501H19.4999C19.2642 16.1501 19.1463 16.1501 19.0731 16.0768C18.9999 16.0036 18.9999 15.8858 18.9999 15.6501V7.02019C18.9999 6.12953 18.9999 5.6842 18.8037 5.64098C18.6074 5.59776 18.4204 6.00188 18.0462 6.81013L12.3982 19.0098C11.8064 20.2879 11.5106 20.927 11.8055 21.3885C12.1004 21.8501 12.8047 21.8501 14.2131 21.8501Z",
  fill: "black"
});

function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.488965be.svg";
export { ForwardRef as ReactComponent };